import { useEffect, useState } from "react";
import { CommonService } from "../../../../services/CommonService";
import { useAdvanceSearchContext } from "../AdvanceSearchContextTest";
import { DropDownMultiCheck } from "../DropDownMultiCheck";
import IconDelete from "../../../../layout/others/icon-x.svg";

export default function YearsOFExperience({
  searchObject,
  setSearchObject,
  t
}) {
  const [yearsOfExperienceOptions, setYearsOfExperienceOptions] = useState([]);

  useEffect(
    () =>
      CommonService.getAllYearsExperience().then((data) =>
        setYearsOfExperienceOptions(data)
      ),
    []
  );

  function setSelectedYearsOfExperienceOptions(list) {
    setSearchObject({ ...searchObject, yearsOfExperienceOptions: list });
  }

  function clearYearsExperience() {
    let _searchObject = { ...searchObject };
    _searchObject.yearsOfExperienceOptions = [];

    setSearchObject(_searchObject);
  }

  return (
    <div>
      <legend className="fontsize-legend">{t("Years of Experience")}</legend>
      {searchObject.yearsOfExperienceOptions?.length !== 0 && (
        <button
          onClick={clearYearsExperience}
          className="btn-clear-language-level position-clear-button"
        >
          <img src={IconDelete} alt="ico-ppl" height="12px" width="auto" />
        </button>
      )}
      <DropDownMultiCheck
        dataList={yearsOfExperienceOptions}
        selecteds={searchObject.yearsOfExperienceOptions}
        setSelecteds={setSelectedYearsOfExperienceOptions}
      />
    </div>
  );
}
